import jwtDecode from 'jwt-decode';
import * as ls from 'local-storage';
import { SnackbarProvider } from 'notistack';
import { CookiesProvider } from 'react-cookie';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';

import CssBaseline from '@mui/material/CssBaseline';
import { StyledEngineProvider, ThemeProvider } from '@mui/material/styles';

import CustomTheme from './CustomTheme';
import './global-styles/global-styles.scss';
import { localConfig } from './localConfig';
import {
  loginSuccess,
  setRoles,
  setUserData,
} from './redux-store/auth/authSlice';
import { setConfig } from './redux-store/global/globalSlice';
import {
  setDaysUntilExpiry,
  setNotary,
} from './redux-store/ipenNotary/ipenNotarySlice';
import { store } from './redux-store/store';
import AppRouter from './routers/AppRouter';

const offices: any = ls.get('offices');
const idToken: any = ls.get('IdToken');
const isGuest: any = ls.get('IsGuest');

const commissionExpirationDate: any = ls.get('CommissionExpirationDate');
const commissionStatus: any = ls.get('CommissionStatus');

declare global {
  interface Window {
    __env: any;
  }
}

const envVars = window.__env;

if (offices && idToken) {
  const userData: any = jwtDecode(idToken);
  userData.initials =
    userData.given_name?.charAt(0) + userData.family_name?.charAt(0);
  if (userData && offices) {
    store.dispatch(loginSuccess(userData));
    store.dispatch(setUserData(offices));
    store.dispatch(setRoles());
    store.dispatch(
      setNotary({
        CommissionExpirationDate: commissionExpirationDate,
        Status: commissionStatus,
      })
    );
    store.dispatch(setDaysUntilExpiry(commissionExpirationDate));
  }
}

if (isGuest && idToken) {
  const userData: any = jwtDecode(idToken);
  userData.initials =
    userData.given_name?.charAt(0) + userData.family_name?.charAt(0);
  if (userData) {
    store.dispatch(loginSuccess(userData));
    store.dispatch(setUserData({}));
    store.dispatch(setRoles());
  }
}

if (envVars) {
  store.dispatch(setConfig(envVars));
} else {
  window.__env = localConfig;
}

ReactDOM.render(
  <Provider store={store}>
    <SnackbarProvider maxSnack={3}>
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={CustomTheme}>
          <CssBaseline />
          <CookiesProvider>
            <AppRouter />
          </CookiesProvider>
        </ThemeProvider>
      </StyledEngineProvider>
    </SnackbarProvider>
  </Provider>,
  document.getElementById('app')
);
export { getWindowDimensions } from './utils/helpers';
